<template>
    <div class="tab_content">
        <span class="tab_content-title">{{ $t('editorPlaceholdersTitle') }}</span>
        <div class="tab_grid">
            <div class="placeholder_form_item"
                v-for="(placeholder, index) in placeholderUserInputs"
                :key="`placeholder-${index}`"
            >
                <div class="form-group">
                    <label :for="placeholder.placeholderObj.placeholderSystemName">{{ placeholder.placeholderObj.placeholderName }}</label>
                    <input
                        :id="placeholder.placeholderObj.placeholderSystemName"
                        v-model="placeholderUserInputs[index].content"
                        type="text"
                        :name="placeholder.placeholderObj.placeholderSystemName"
                        :ref="`placeholder-${placeholder.placeholderObj.placeholderSystemName}`"
                        @input="changePlaceholder(index, placeholder.ids)"
                    />
                    <div v-if="areElementsLoaded">
                        <span v-if="placeholderErrors.find(error => error.placeholderId === placeholder.placeholderObj.placeholderId).hasError" class="placeholderError">{{ placeholderErrors.find(error => error.placeholderId === placeholder.placeholderObj.placeholderId).errorMessage }}</span>
                    </div>
                </div>
            </div>
            <div
                v-if="placeholderCustomContentIsVisible"
                v-html="getSessionDetails.editorSetup.customContent.placeholderFormDisclaimer"
            />
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { messenger, handlers as messengerHandlers } from '../../../js/messenger';
    import { qrSvg } from '../../../js/qrCodeSvg';

    export default {
        data() {
            return {
                placeholderUserInputs: null,
                placeholderErrors: [],
                qrElements: []
            }
        },
        methods: {
            elements() {
                const pages = this.getPages;
                let elements = [];
                pages.forEach(page => {
                    const placeholderUserInputs = page.content.elements.filter(element => element.placeholder !== undefined).filter(element => element.placeholder.hasPlaceholder === true);
                    elements = [...elements, ...placeholderUserInputs]
                });

                let placeholders = elements.map(el => ({
                    placeholderObj: el.placeholder,
                    content: this.getPlaceholderUserInputs !== null ? el.content : this.$i18n.t('editorTabPlaceholdersContent'),
                    ids: [],
                    hasError: false,
                    errorMessage: null
                }));
                
                placeholders = placeholders.map(placeholder => {
                    const placeholderSystemName = placeholder.placeholderObj.placeholderSystemName;

                    const elementsForPlaceholders = elements.filter(el => el.placeholder.placeholderSystemName === placeholderSystemName);

                    let ids = [];
                    elementsForPlaceholders.forEach(el => ids.push(el.id));
                    
                    return {
                        ...placeholder,
                        ids
                    }
                })

                let uniquePlaceholders = placeholders.filter((el, i, arr) => {
                    return arr.findIndex(obj => obj.placeholderObj.placeholderId === el.placeholderObj.placeholderId) === i
                });

                uniquePlaceholders.map(placeholder => {
                    const newestPlaceholderValues = this.getPlaceholders.find(item => item.id === placeholder.placeholderObj.placeholderId).name;
                    placeholder.placeholderObj.placeholderName = newestPlaceholderValues;
                });

                return uniquePlaceholders;
            },
            getQrElements() {
                const pages = this.getPages;

                let qrEl = [];

                pages.forEach(page => {
                    const pageQrElements = page.content.elements.filter(element => element.type === 'QR_CODE_ELEMENT').filter(element => element.placeholder.hasPlaceholder === true);

                    qrEl.push(...pageQrElements);
                });

                this.qrElements = qrEl;
            },
            changePlaceholder(index, elementIds) {
                const activePlaceholder = this.placeholderUserInputs[index];
                this.$nextTick(() => {
                    this.$refs[`placeholder-${activePlaceholder.placeholderObj.placeholderSystemName}`][0].focus();
                });
                const payload = {
                    id: activePlaceholder.placeholderObj.placeholderId,
                    content: activePlaceholder.content,
                    contentFromPlaceholder: true
                }
                this.$store.dispatch('SET_PLACEHOLDER_CONTENT', payload);

                elementIds.forEach(el => {
                    let textPayload = {
                        id: el,
                        content: activePlaceholder.content,
                        contentFromPlaceholder: true
                    }
                    this.$store.dispatch('CHANGE_TEXT', textPayload);
                });

                this.qrElements.forEach(element => {
                    qrSvg(element.content, element.frontColor, element.backColor, element.width, element.id);
                });

                elementIds.forEach(el => {
                    this.validateFields(index);
                });                
            },
            validateFields(index) {
                const activePlaceholder = this.placeholderUserInputs[index];
                const activePlaceholderId = activePlaceholder.placeholderObj.placeholderId;
                const that = this;
                messenger.validatePlaceholderField({
                    'systemName': activePlaceholder.placeholderObj.placeholderSystemName,
                    'value': activePlaceholder.content,
                }).then(function (result) {
                    const errorObj = that.placeholderErrors.find(error => error.placeholderId === activePlaceholderId);
                    if (result.isValid === false) {
                        if (errorObj.hasError === false) {
                            errorObj.hasError = true;
                            errorObj.errorMessage = result.message;
                        } else {
                            if (errorObj.errorMessage !== result.message) {
                                errorObj.errorMessage = result.message;
                            }
                        }
                    } else {
                        errorObj.hasError = false;
                        errorObj.errorMessage = null;
                    }

                    that.setContentFromValidation(result.systemName, result.value);
                    console.log('Field Success!', result);
                }, function (error) {
                    console.log('Field Error!', error);
                });
            },
            setContentFromValidation(placeholderSystemName, content) {
                const elementsWithPlaceholder = this.getAllElements.filter(el => Object.keys(el).includes('placeholder')).filter(el => el.placeholder.hasPlaceholder).filter(el => el.placeholder.placeholderSystemName === placeholderSystemName);
                
                elementsWithPlaceholder.forEach(el => {
                    let textPayload = {
                        id: el.id,
                        content,
                        contentFromPlaceholder: true
                    }
                    this.$store.dispatch('CHANGE_TEXT', textPayload);
                });
                
            }
        },
        watch: {
            elements: {
                deep: true,
                handler: function() {
                    this.placeholderUserInputs = this.getPlaceholderUserInputs;
                    this.$store.dispatch('SET_PLACEHOLDER_USER_INPUTS', this.placeholderUserInputs);
                }
            },
            getPages: {
                deep: true,
                handler: function() {
                    this.getQrElements();
                    this.placeholderUserInputs = this.elements();
                    this.$store.dispatch('SET_PLACEHOLDER_USER_INPUTS', this.placeholderUserInputs);
                }
            },
            getActiveElement: {
                deep: true,
                handler: function() {
                    if (Object.keys(this.getActiveElement).includes('placeholder')) {
                        const activeElementPlaceholderId = this.getActiveElement.placeholder.placeholderId;
                        if (activeElementPlaceholderId !== 'noPlaceholder') {
                            const payload = {
                                id: activeElementPlaceholderId,
                                content: this.getActiveElement.content
                            }

                            this.$store.dispatch('SET_PLACEHOLDER_CONTENT', payload);
                        }
                    }

                }
            },
            getPlaceholderUserInputs: {
                deep: true,
                handler: function() {
                    this.placeholderUserInputs = this.getPlaceholderUserInputs;

                    if (this.placeholderUserInputs.length > this.placeholderErrors.length) {
                        this.placeholderErrors.push({ hasError: false, errorMessage: null, placeholderId: this.placeholderUserInputs[this.placeholderUserInputs.length - 1].placeholderObj.placeholderId });
                    }

                    if (this.placeholderErrors.length > this.placeholderUserInputs.length) {
                        const that = this;
                        function filterOutError(value) {
                            
                            const hasError = that.placeholderUserInputs.findIndex(e => e.placeholderObj.placeholderId === value.placeholderId);
                            if (hasError !== -1) {
                                return value;
                            }
                        }
                        this.placeholderErrors = this.placeholderErrors.filter(filterOutError)
                    }

                    if (Object.keys(this.getActiveElement).length > 0) {
                        if (Object.keys(this.getActiveElement).includes('placeholder')) {
                            if (this.getActiveElement.placeholder.hasPlaceholder) {
                                const placeholderIndex = this.placeholderUserInputs.findIndex(placeholder => placeholder.placeholderObj.placeholderId === this.getActiveElement.placeholder.placeholderId);

                                this.validateFields(placeholderIndex);
                            }
                        }
                    }
                }
            },
            areElementsLoaded: {
                deep: true,
                handler: function() {
                    this.placeholderUserInputs.forEach((item, index) => {
                        this.validateFields(index);
                    });
                }
            },
            areElementsChanging: {
                deep: true,
                handler: function() {
                    if (this.areElementsChanging === true) {
                        this.placeholderUserInputs.forEach((placeholder, index) => {
                            this.placeholderErrors.push({ hasError: false, errorMessage: null, placeholderId: this.placeholderUserInputs[index].placeholderObj.placeholderId });
                        });
                    }
                }
            }
        },
        computed: {
            ...mapGetters([
                'getPages',
                'getPlaceholderUserInputs',
                'getSessionDetails',
                'getActiveElement',
                'getPlaceholders',
                'getAllElements',
                'areElementsLoaded',
                'areElementsChanging'
            ]),
            placeholderCustomContentIsVisible() {
                if (this.getSessionDetails.mode === 'user') {
                    console.log('sessiondetails: ', this.getSessionDetails)
                    if (this.getSessionDetails.editorSetup.customContent.placeholderFormDisclaimer !== "") {
                        return true;
                    } return false;
                } return false;
            }
        },
        created() {
            this.placeholderUserInputs = this.elements();
            this.placeholderUserInputs.forEach((placeholder, index) => {
                this.placeholderErrors.push({ hasError: false, errorMessage: null, placeholderId: this.placeholderUserInputs[index].placeholderObj.placeholderId });
            });
            this.getQrElements();
        },
        mounted() {
            // this.placeholderUserInputs.forEach((item, index) => {
            //     this.validateFields(index);
            // })
        }
    }
</script>

<style lang="scss" scoped>
    .placeholder_form_item .form-group {
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;

        input {
            width: 60%;
            padding: 8px;
            border-radius: 3px;
            border:1px solid #fff;
            box-sizing: border-box;
        }

        span {
            color: #ff4040;
            margin: 5px 0;
            display: block;
        }
    }

    @media (max-width: 1200px) {
        .placeholder_form_item .form-group {
            flex-direction: column;
            align-items: flex-start;

            label {
                margin-bottom: 3px;
            }

            input {
                width: 100%;
                font-size: 12px;
            }
        }
    }
</style>